export default "__VITE_ASSET__DgXQX4D2__"